import { ITopProductProps } from '../../../../../../topProduct.models';
import * as S from '../../topNavigationLiteCard.style';
import { CustomText } from '@vfit/shared/atoms';
import TopNavigationLiteCardPopupTagging from './topNavigationLiteCardPopup.tagging';

export const TopNavigationLiteCardPopup = ({ product }: ITopProductProps) => {
  const { pdpLitePopupDescription, pdpLitePopupTitle } = product;
  return (
    <>
      <TopNavigationLiteCardPopupTagging product={product} />
      <S.ModalTitle>
        <CustomText size={36} lineHeight={45} textAlign="left" text={pdpLitePopupTitle || ''} />
      </S.ModalTitle>
      <S.ModalContent>
        <CustomText
          size={18}
          lineHeight={24}
          textAlign="left"
          text={pdpLitePopupDescription || ''}
        />
      </S.ModalContent>
    </>
  );
};
